import React, { useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Icon from '../Icon'

function ContactPicker({ images }) {
  const [currentCalendylUrl, setCurrentCalendlyUrl] = useState(null)

  return (
    <div>
      {!currentCalendylUrl && (
        <div className="flex flex-col gap-x-4 bg-white mt-10 items-center">
          <iframe
            title="Book a Meeting"
            src="https://calendly.com/submit-pengilleymyersapc/"
            width="100%"
            className="h-[70vh]"
            height="100%"
          ></iframe>
          {/* <div className="text-gray-500 font-semibold text-sm mt-[36px]">
            Web Inquiries
          </div>
          <div className="text-sm text-gray-500 mb-[44px] mt-[36px] px-[70px] text-center">
            Book a complimentary 30-minute consultation with our Pengilley Myers
            APC team to discuss your Lemon Law, fraud, or mediation situation
            and how we can be of service.
          </div>
          <div className="flex flex-col md:flex-row gap-y-4 gap-x-4 mb-8 md:mb-0">
            {partners.map((partner, index) => (
              <ContactItem
                name={partner.name}
                role={partner.role}
                calendlyUrl={partner.calendlyUrl}
                image={images[index]}
                setCurrentCalendlyUrl={setCurrentCalendlyUrl}
              />
            ))}
            
          </div> */}
        </div>
      )}
      <div>
        {currentCalendylUrl && (
          <ContactCalendly
            currentCalendylUrl={currentCalendylUrl}
            setCurrentCalendlyUrl={setCurrentCalendlyUrl}
          />
        )}
      </div>
    </div>
  )
}

const ContactItem = ({
  name,
  role,
  calendlyUrl,
  image,
  setCurrentCalendlyUrl,
}) => {
  const handleClick = () => {
    setCurrentCalendlyUrl(calendlyUrl)
  }
  return (
    <div
      className="w-[173px] h-[196px] rounded border-[1px] border-accent_orange_600 hover:bg-accent_orange_100 flex flex-col gap-y-[6px] items-center"
      onClick={handleClick}
    >
      <div className="w-20 h-20 rounded-[50%] mt-5 overflow-hidden">
        <GatsbyImage image={image.childImageSharp.gatsbyImageData} />
      </div>
      <div className="font-semibold text-lg px-5 leading-[21.94px]">{name}</div>
      <div className="font-normal text-sm text-[#7A7A7A]">{role}</div>
    </div>
  )
}

const ContactCalendly = ({ currentCalendylUrl, setCurrentCalendlyUrl }) => {
  const handleClick = () => {
    setCurrentCalendlyUrl(null)
  }

  return (
    <div className="flex flex-col">
      <div
        className="flex items-center gap-x-2 pt-4 cursor-pointer"
        onClick={handleClick}
      >
        <span className="p-[5px] rounded-full border-[1px] border-gray-300 block ">
          <Icon icon="golden-left-arrow-icon" iconHeight={18} iconWidth={18} />
        </span>
        <span className="text-white hover:text-accent_orange_600 transition-all ease-linear duration-300">
          Go Back
        </span>
      </div>
      <div className="mt-5">
        <iframe
          title="Book a Meeting"
          src={currentCalendylUrl}
          width="100%"
          className="h-[70vh]"
          height="100%"
        ></iframe>
      </div>
    </div>
  )
}
const partners = [
  {
    name: 'Stephanie S. Pengilley, Esq.',
    role: 'Founding Partner',
    image: '001.jpg',
    calendlyUrl: 'https://calendly.com/submit-pengilleymyersapc/',
  },
  {
    name: 'John P. Myers, Esq.',
    role: 'Founding Partner',
    image: '002.jpg',
    calendlyUrl: 'https://calendly.com/submit-pengilleymyersapc/',
  },
]
export default ContactPicker
